import { forwardRef } from 'react';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { colors } from 'app/common/arctechv2/theme';


/* @jsxImportSource @emotion/react */  import { css, jsx } from '@emotion/react'; /* eslint-disable-line */

const getAccessibleColor = (bgColor) => {
    if (!bgColor) {
        return '#111928';
    }

    let color = bgColor.substring(1, 7);
    let r = parseInt(color.substring(0, 2), 16);
    let g = parseInt(color.substring(2, 4), 16);
    let b = parseInt(color.substring(4, 6), 16);

    let yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

    return (yiq >= 128) ? '#111928' : '#FFFFFF';
}

export default forwardRef(({element: Element = 'button', type, id, to, className, size, title, isRequesting, onClick, disabled, style, children, variant = 'solid', color = '#1C64F2', textColor, ...rest}, ref) => {
    const secondaryColor = textColor ?? getAccessibleColor(color);

    const componentCss = css`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-family: 'Inter', sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 150%;
        border: 1px solid ${color};
        background: ${variant === 'invert' ? 'transparent' : color};
        color: ${variant === 'invert' ? color : secondaryColor} !important;
        border-radius: 8px;
        padding: 8px 12px;

        &[disabled] {
            cursor: not-allowed;
            opacity: 0.5;
            filter: grayscale(1);
        }
        &:focus {
            outline: none;
        }

        &:not([disabled]):hover {
            border: 1px solid ${variant === 'invert' ? secondaryColor : color};
            background: ${variant === 'invert' ? color : secondaryColor};
            color: ${variant === 'invert' ? secondaryColor : color} !important;
            text-decoration: none;
        }

        &.block {
            display: block;
            width: 100%;
        }

        // sizes
        &.small {
            font-size: 10px;
            padding: 6px 8px;
        }
        &.slim {
            font-size: 10px;
            padding: 3px 8px;
        }
        &.rounded {
            border-radius: 20px;
        }
        &.filterButton {
            padding-top: 12px;
            padding-bottom: 12px;
        }

        &.noborder {
            border: none;
            &:hover {
                border: none;
            }
        }
        &.grayBorder {
            border-color: ${colors.gray300}
        }
    `;
    
	const handleClick = onClick && useCallback((ev) => {
		ev.preventDefault();
		if (onClick) {
			onClick(ev);
		}
	}, [onClick]);

    if (Element === 'a' && to) { Element = 'div'; }

    const component = <Element css={componentCss} className={className + (size ? ' ' + size : '')} title={title} type={type} style={style} id={id} onClick={handleClick} disabled={disabled || isRequesting} {...rest}>
        {isRequesting ? <i className="fa-solid fa-spin fa-spinner"></i> : children}
    </Element>

	if (to) {
		return <Link to={to}>
            {component}
        </Link>
	}

	return component;
})